<fieldset class="estoque-card" *ngIf="temModuloEstoque">
  <div class="estoque-card-cabecalho">
    <div class="estoque-card-titulo">
      <span class="estoque-card-icone"><i class="fas fa-cube" aria-hidden="true"></i></span>
      <div>
        <h4>Controle de estoque</h4>
        <p>Vincule um insumo do estoque e defina como a baixa será feita.</p>
      </div>
    </div>
    <label class="estoque-ativar" for="controlarEstoque">
      <input name="controlarEstoque" id="controlarEstoque" class="k-checkbox" type="checkbox" kendoCheckBox
             [(ngModel)]="objeto.controlarEstoque" (ngModelChange)="alterouControlarEstoque()" />
      <span>Ativar controle de estoque</span>
    </label>
  </div>
  <div class="row">
    <ng-container *ngIf="objeto.controlarEstoque">
      <div class="col-12" *ngIf="!empresa.estoqueVinculadoProduto">
        <div class="estoque-associacao" [class.estoque-associacao--produto]="tipo === 'produto'">
          <div class="estoque-vinculo estoque-campo-card">
            <ng-container *ngIf="tipo === 'produto' && objeto.momentoBaixaEstoque === 'producao'; else vinculoVenda">
              <label>Fichas permitidas para a produção
                <i class="k-icon k-i-loading ml-1" *ngIf="carregandoInsumo"></i>
              </label>
              <kendo-multiselect name="fichasProducao" class="fichas-producao" [data]="fichasProducaoFiltradas"
                                 textField="nome" valueField="id" [(ngModel)]="objeto.fichasProducao"
                                 (ngModelChange)="estoqueAlterado = true"
                                 [filterable]="true" (filterChange)="filtreFichasProducao($event)"
                                 [disabled]="carregandoInsumo" placeholder="Selecione uma ou mais fichas técnicas">
              </kendo-multiselect>
              <small class="text-muted d-block mt-1">
                São receitas alternativas: cada produção usará apenas a ficha escolhida, sem somar as composições.
              </small>
            </ng-container>
            <ng-template #vinculoVenda>
              <label>Insumo do estoque
                <i class="k-icon k-i-loading ml-1" *ngIf="carregandoInsumo"></i>
              </label>
              <kendo-dropdowntree #dropdowntree kendoDropDownTreeExpandable name="item" *ngIf="data.length" class="form-control furniture" required
                                  [kendoDropDownTreeHierarchyBinding]="data" [(ngModel)]="objeto.insumo" [filterable]="true"
                                  textField="nome" valueField="id" childrenField="items"
                                  [isNodeExpanded]="isNodeExpanded" (nodeExpand)="handleExpand($event)" (nodeCollapse)="handleCollapse($event)"
                                  [disabled]="carregandoInsumo" (valueChange)="onValueChange($event)"
                                  (filterChange)="onFilterInsumo($event)">
                <ng-template kendoDropDownTreeNodeTemplate let-dataItem>
                  <span [class.insumo-grupo-label]="dataItem.items?.length"
                        (click)="onNodeLabelClick($event, dataItem)">{{dataItem.nome}}</span>
                </ng-template>
              </kendo-dropdowntree>
            </ng-template>
            <div class="estoque-resumo" *ngIf="tipo !== 'produto' || objeto.momentoBaixaEstoque !== 'producao'">
              <span>
                <i class="fas fa-cubes" aria-hidden="true"></i>
                Atual: <strong>{{objeto.insumo?.estoque?.quantidade ?? '—'}} {{objeto.insumo?.unidadeMedida?.sigla}}</strong>
              </span>
              <span>
                <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
                Mínimo: <strong>{{objeto.insumo?.estoque?.quantidadeMinima ?? '—'}} {{objeto.insumo?.unidadeMedida?.sigla}}</strong>
              </span>
            </div>
          </div>
          <div class="estoque-consumo estoque-campo-card" *ngIf="tipo === 'produto'">
            <label>Consumo do estoque</label>
            <div class="estoque-consumo-opcoes">
              <label class="estoque-consumo-opcao" [class.selecionada]="objeto.momentoBaixaEstoque !== 'producao'">
                <input kendoRadioButton type="radio" name="momentoBaixaEstoque" [value]="null"
                       [(ngModel)]="objeto.momentoBaixaEstoque" (ngModelChange)="alterouMomentoBaixa()" />
                <span>Na venda</span>
              </label>
              <label *ngIf="producaoPedidosAtiva" class="estoque-consumo-opcao" [class.selecionada]="objeto.momentoBaixaEstoque === 'producao'">
                <input kendoRadioButton type="radio" name="momentoBaixaEstoque" value="producao"
                       [(ngModel)]="objeto.momentoBaixaEstoque" (ngModelChange)="alterouMomentoBaixa()" />
                <span>Na produção</span>
              </label>
            </div>
          </div>
        </div>
        <small class="estoque-consulta-info" *ngIf="tipo !== 'produto' || objeto.momentoBaixaEstoque !== 'producao'">
          <i class="fas fa-info-circle mr-1" aria-hidden="true"></i>
          As quantidades são exibidas apenas para consulta. Para alterá-las, use o gerenciamento de estoque.
        </small>
      </div>
      <ng-container *ngIf="empresa.estoqueVinculadoProduto">
        <div class="form-group  col-3">
          <label  >Estoque atual
            <i class="k-icon k-i-list-bulleted cpointer text-blue ml-1" *ngIf="objeto.estoque.id"
               (click)="abraModalMovimentacoes(objeto)"  style="    margin-top: -3px  " title="ver movimentações" kendoTooltip></i>
          </label>
          <kendo-numerictextbox   [min]="0"   [format]="obtenhaFormatoEstoque()"
                                class="form-control" name="incremento" #incremento=ngModel

                                [(ngModel)]="objeto.estoque.quantidade" (ngModelChange)="estoqueAlterado = true" required placeholder="Estoque atual">
          </kendo-numerictextbox>


        </div>

        <div class="form-group  col-3" *ngIf="objeto.estoque?.id">
          <label  >Estoque reservado
            <i class="fas fa-info-circle text-blue" kendoTooltip  title="Quantidade desse produto que está reservado em pedidos não finalizados"></i>
          </label>
          <kendo-numerictextbox      [format]="obtenhaFormatoEstoque()"  [disabled]="true"
                                     class="form-control" name="quantidadeReservada" #quantidadeReservada=ngModel
                                     [(ngModel)]="objeto.estoque.quantidadeReservada"  >
          </kendo-numerictextbox>

        </div>

        <div class="form-group  col-3">
          <label  >Estoque minimo
            <i class="fas fa-info-circle text-blue" kendoTooltip
               title="Alerta é disparado quanto o produto atigir o minimo no estoque"></i>
          </label>
          <kendo-numerictextbox   [min]="1"   [format]="obtenhaFormatoEstoque()"
                                class="form-control" name="estoqueMinimo" #estoqueMinimo=ngModel

                                [(ngModel)]="objeto.estoque.quantidadeMinima" (ngModelChange)="estoqueAlterado = true" required placeholder="Estoque minimo">
          </kendo-numerictextbox>

        </div>



      </ng-container>

    </ng-container>
  </div>
</fieldset>
